export * from './compatibility';
import { toFormattedDate } from '.';
import { loadCookie, saveCookie } from './cookie';
import SbsPlayerLogger from './logger';
import { getMD5 } from './md5';

/**
 * smr 요청사항, 플레이어(브라우저)의 고유 식별사용자 아이디를 조회/생성(쿠키저장)
 * - 조합식 'SMR_MEMBERS' + yyyyMMddHHmmss + 'user ip' => md5 hash 적용
 *
 * @export
 * @param {*} media
 * @param {*} ip
 * @return {*}
 */
export function getUUID(media, ip) {
  let sbsUUIDKey = 'SBS_PLAYER_UUID';
  let savedUUID = loadCookie(sbsUUIDKey);

  if (savedUUID.length == 32) {
    return savedUUID;
  } else {
    let uuid = getMD5(
      media + toFormattedDate(new Date(), 'yyyyMMddHHmmss') + ip
    );
    saveCookie(sbsUUIDKey, uuid);
    return uuid;
  }
}

export function getTID(media, ip) {
  // TODO: 2-4. 개발가이드 – TID 구현
  // • TID
  // – 한 번의 라이브 시청을 나타내는 Unique ID
  // – TID = (프리롤 광고 +) 라이브 채널 시청(동일 채널)
  // • TID 를 새로 생성하는 경우
  // – 라이브 채널 처음 진입 시(& 큐 초기화)
  // • 프리롤 광고 있다면, 프리롤 광고 요청부터
  // – 채널 변경 시(& 큐 초기화)
  // – 라이브 시청 도중 pause & play 한 경우(& 큐 초기화)
  // • 사용자가 pause & play 한 경우
  // • 재난 문자 수신 등으로 pause 된 경우
  // – 앱이 백그라운드로 전환되었다고 돌아오는 경우(& 큐 초기화)
  // • 재난 문자 수신 등으로 앱이 백그라운드로 전환된 경우
  // • TID 를 새로 생성하지 않는 경우
  // – 광고 구간 종료, 화질 변경

  let sbsTIDKey = 'SBS_PLAYER_TID';
  let savedTID = loadCookie(sbsTIDKey);

  if (savedTID.length == 32) {
    return savedTID;
  } else {
    let tid = getMD5(
      getUUID(media, ip) +
        toFormattedDate(new Date(), 'yyyyMMddHHmmss') +
        getRandomInteger()
    );
    saveCookie(sbsTIDKey, tid);
    return tid;
  }
}

export function getRandomInteger() {
  let randomInteger = Math.floor(Math.random() * 100000) + 10000;

  if (randomInteger > 100000) {
    randomInteger = randomInteger - 10000;
  }

  return Math.floor(randomInteger);
}
